import Tooltip from '@mui/material/Tooltip';

export default function ActiveBadge({ children, value, className = '' }) {
  const badgeClass = value
    ? 'bg-green-100 text-green-500'
    : 'bg-gray-100 text-gray-500';

  const badge = (
    <div
      className={`${badgeClass} flex justify-center items-center text-xs rounded-full max-w-min px-2 py-1 ${className}`}
    >
      {children}
    </div>
  );

  if (value) return badge;

  return (
    <Tooltip
      arrow
      placement="top"
      enterDelay={250}
      enterTouchDelay={50}
      leaveTouchDelay={3000}
      title="This team is not currently active. You need to edit the team and resubmit, if you want this team to officially be added to the competition."
    >
      <span className="inline-block">{badge}</span>
    </Tooltip>
  );
}
